import { useEffect, useState } from "react";
import axios from "axios";
import { API, formatApiError } from "@/lib/api";
import ExerciseWorksheet from "@/components/ExerciseWorksheet";
import { Button } from "@/components/ui/button";

export default function PatientExerciseProgram() {
  const [program, setProgram] = useState(null);
  const [error, setError] = useState("");
  const [token, setToken] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get("token") || "");
  useEffect(() => {
    const updateToken = () => setToken(new URLSearchParams(window.location.hash.slice(1)).get("token") || "");
    window.addEventListener("hashchange", updateToken);
    return () => window.removeEventListener("hashchange", updateToken);
  }, []);
  useEffect(() => {
    document.title = "Exercise program | Bexley Road Physiotherapy";
    setProgram(null);
    setError("");
    let active = true;
    if (!token) {
      setError("This program link is incomplete. Please open the full link in your email or contact the clinic.");
      return;
    }
    axios.post(`${API}/patient/exercise-program`, { token }).then(({ data }) => {
      if (active) setProgram(data);
    }).catch((err) => {
      if (active) setError(err.response?.status === 422
        ? "This program link is invalid. Please contact the clinic."
        : err.response?.data?.detail ? formatApiError(err.response.data.detail) : "Unable to load your program. Check your connection and try again.");
    });
    return () => { active = false; };
  }, [token]);
  return <main className="program-page mx-auto max-w-3xl p-4 sm:p-8">
    <div className="program-controls mb-4">
      {program && <><Button onClick={() => window.print()}>Print Worksheet</Button><p className="mt-2 text-sm text-slate-500">Choose “Save as PDF” in your browser’s print dialog to save a copy.</p></>}
      {error && <p role="alert" className="rounded-xl bg-rose-50 p-4 text-rose-700">{error}</p>}
      {!error && !program && <p role="status">Loading your exercise program…</p>}
    </div>
    {program && <ExerciseWorksheet program={program} showVideos />}
  </main>;
}
